module.exports = __webpack_public_path__ + "img/report_info_name.b83cfdaa.png";